import React, { useState, useEffect } from 'react';
import './Footer.scss';
import { FaFacebook, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
//import { AiFillLinkedin, AiFillInstagram, AiFillTwitterCircle, AiFillYoutube } from 'react-icons/ai';



const Footer = () => {

    const [isAdminPanel, setIsAdminPanel] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (history.location.pathname.includes('admin-panel'))
            setIsAdminPanel(true);

        history.listen(() => {
            if (history.location.pathname.includes('admin-panel'))
                setIsAdminPanel(true);
            else
                setIsAdminPanel(false);

            console.log(history.location.pathname);
        });
    }, []);

    if (isAdminPanel) {
        return (<></>);
    }

    return (

        <div className="social-body ">
            <div className="social-buttons mt-1">
                <a href="hhttps://www.facebook.com/MonarchLeos" className="social-buttons__button social-button social-button--facebook" aria-label="Facebook" data-aos="zoom-in">
                    <span className="social-button__inner">
                        <FaFacebook />
                        {/* <i className="fab fa-facebook-f"></i>
                        <FaFacebook /> */}
                    </span>
                </a>
                <a href="#" className="social-buttons__button social-button social-button--linkedin" aria-label="LinkedIn" data-aos="zoom-in">
                    <span className="social-button__inner">
                        <FaLinkedin />
                        {/* <i className="fab fa-linkedin-in"></i>
                        <AiFillLinkedin /> */}
                    </span>
                </a>
                <a href="https://instagram.com/lc_colombo_monarch?utm_medium=copy_link" className="social-buttons__button social-button social-button--instagram" aria-label="instagram" data-aos="zoom-in">
                    <span className="social-button__inner">
                        {/* <i className="fab fa-instagram-ghost"></i>
                        <AiFillInstagram /> */}
                        <FaInstagram />
                    </span>
                </a>

                <a href="https://www.youtube.com/channel/UCtoEBWUvMFgqr3nDQWHTiGg" className="social-buttons__button social-button social-button--youtube" aria-label="youtube" data-aos="zoom-in">
                    <span className="social-button__inner">
                        <FaYoutube />
                        {/* <i className="fab fa-youtube"></i>
                        <AiFillYoutube /> */}
                    </span>
                </a>
            </div>
            <p className="copyright-body mt-2 ">Copyright © 2023 Leo Club of Colombo Monarch</p>
        </div>

    );
};

export default Footer;
